import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';

/**
 * Injectable wrapper around `environment.sensitiveDataMaskingEnabled` (UNIVAPLAT-2788).
 *
 * Exists per the Tech Lead Assessment's testability guidance: components that gate
 * masking behaviour on the flag inject this class instead of reading the environment
 * const directly, so specs can exercise BOTH flag states via a TestBed provider
 * override ({provide: SensitiveDataMaskingConfig, useValue: {enabled: true|false}}).
 *
 * Consumers: MaskedFieldComponent (UNIVAPLAT-2788),
 * BatchRevealButtonComponent (UNIVAPLAT-2789 — same dormancy pattern).
 */
@Injectable({providedIn: 'root'})
export class SensitiveDataMaskingConfig {
    readonly enabled: boolean = environment.sensitiveDataMaskingEnabled;
}
